import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import { LoadingButton } from "@atlaskit/button";

import { useSignupFormContext } from "@/components/signup/bxp-ui-signup/src/components/signup-form/hooks";
import { trackSignUpWithEmail } from "@/components/signup/utils";

type ButtonSubmitType = {
    submitting: boolean;
    isEmailValid: boolean;
    hasSubmitted: boolean;
    formError: boolean;
    hasRebrandedSignupFormStyles?: boolean;
};

export const ButtonSubmit = ({
    submitting,
    hasSubmitted,
    formError,
    hasRebrandedSignupFormStyles
}: ButtonSubmitType) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const intl = useIntl();

    const { isSubmitting: formContextSubmitting } = useSignupFormContext();

    const submitMessage = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });

    const submitButtonStyle = hasRebrandedSignupFormStyles
        ? {
              ...baseSubmitButtonStyle,
              ...roundedSubmitButtonStyle
          }
        : baseSubmitButtonStyle;

    return (
        <LoadingButton
            css={[submitButtonCss]}
            style={submitButtonStyle}
            className="SignupSubmitBtn"
            shouldFitContainer
            type="submit"
            appearance="primary"
            isDisabled={
                formContextSubmitting ||
                submitting ||
                (hasSubmitted && !formError)
            }
            isLoading={
                formContextSubmitting ||
                submitting ||
                (hasSubmitted && !formError)
            }
            onClick={() => trackSignUpWithEmail(createAnalyticsEvent)}
        >
            <span id="SubmitMessage">{submitMessage}</span>
        </LoadingButton>
    );
};

const submitButtonCss = css({
    fontWeight: 400,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    span: {
        alignSelf: "center"
    }
});

const baseSubmitButtonStyle = {
    height: 40
};

const roundedSubmitButtonStyle = {
    borderRadius: "40px"
};
